import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { BackButton, LogoutButton, NavBar } from '../../../components/layout/NavBar'
import { Services } from '@/services/services'
import { useNavigate } from 'react-router-dom'

import './Dashboard.module.css'
import { callMeBtn } from '@/components/Elements/CallMeBtn'
import { Translates } from '@/services/repository/i18n'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInLayout } from '@/components/layout/LoggedInLayout'
import { SuperAdminInsertMachinesPopup } from './machines/Machines'
import { useModal } from '@/components/modal/Modal'
import MapComponent from '@/components/Map/Map'
import { isLargeScreen, isMobile, useResponsiveChange } from '@/common/device'
import { LangsButton, UserLangsButton } from '@/components/layout/Langs'

export const SuperAdminDashboard = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const { translates } = session
  const navigate = useNavigate();

  useResponsiveChange()

  return <LoggedInLayout pageName='dashboard' services={services} session={session} 
    navbarLeft={<LogoutButton services={services} translates={translates} />} 
    navbarRight={<UserLangsButton session={session} services={services} translates={translates} />}  >
    <div className={`superadmin-dashboard content-body ${isLargeScreen() ? 'large' : ''} ${!isMobile() ? 'desktop' : 'mobile'}`}>
      <div className='dashboard-menu'>
        {/* <a className='main-btn' onClick={() => openModal((props) => SuperAdminInsertMachinesPopup({
          ...props, services, session, onInsert: ({ id }) => {
            navigate(`/communal/machine/${id}`)
          }
        }))}>
          {translates.for('menu.addMachine')}
        </a> */}
        <a className='main-btn' onClick={() => navigate('/superadmin/users')}>
          {translates.for('menu.usersMenager')}
        </a>
        <a className='main-btn' onClick={() => navigate('/superadmin/usergroups')}>
          {translates.for('menu.usergroups')}
        </a>
        <a className='main-btn' onClick={() => navigate('/superadmin/companies')}>
          {translates.for('menu.adminCompanies')}
        </a>
        <a className='main-btn' onClick={() => navigate('/superadmin/machines')}>
          {translates.for('menu.adminMachines')}
        </a>
        {/* <a className='main-btn' onClick={() => navigate('/service/teltonika')}>
          {translates.for('menu.deviceMonitoring')}
        </a> */}
        {/* <a className='main-btn' onClick={() => navigate('/service/objects') }>
          {translates.for('menu.deviceMonitoring')}
        </a>
        <a className='main-btn' onClick={() => navigate('/service/teltonika') }>
          {translates.for('menu.teltonikaDeviceMonitoring')}
        </a>
        <a className='main-btn' onClick={() => navigate('/superadmin/nfcreader')}>
          {translates.for('menu.nfcReader')}
        </a> */}
        <a className='main-red-btn' onClick={() => navigate('/communal/qrscanner')}>
          {translates.for('menu.qrscanner')}
        </a>
        <a className='main-red-btn' onClick={() => navigate('/qr/generator')}>
          {translates.for('menu.qrGenerator')}
        </a>
        <a className='main-rgreen-btn' onClick={() => navigate('/communal/contact')}>
          {translates.for('menu.contact')}
        </a>
        <a className='main-green-btn' onClick={() => navigate('/communal/failures/map')}>
          {translates.for('menu.failures_map')}
        </a>
        <a className='main-green-btn' onClick={() => navigate('/communal/hit/map')}>
          {translates.for('menu.hit_map')}
        </a>
        <a className='main-green-btn' onClick={() => navigate('/communal/map')}>
          {translates.for('menu.map')}
        </a>
        <a className='main-green-btn' onClick={() => navigate('/communal/battery/map')}>
          {translates.for('menu.battery_map')}
        </a>
        <a className='main-green-btn' onClick={() => navigate('/superadmin/support/questions')}>
          {translates.for('menu.support_questions')}
        </a>
        {/* {callMeBtn({ services, translates: session.translates })} */}
        {/* <SuperAdminInsertMachinesPopup isOpen={inserted} onClose={() => setInserted(false)} onInsert={({ id }) => {
          navigate(`/communal/machine/${id}`)
        }} services={services} session={session} /> */}
      </div>
      {/* {map()} */}
    </div>
  </LoggedInLayout>
}
